import { useEffect, useState } from "react";
import API from "../../api/api";
import Modal from "../../components/Modal";
import Toast from "../../components/Toast";

function ContactMessages() {
    const [list, setList] = useState([]);
    const [loading, setLoading] = useState(false);
    const [selectedMessage, setSelectedMessage] = useState(null);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [toast, setToast] = useState(null);

    const fetchMessages = () => {
        setLoading(true);
        console.log("Fetching contact messages from /contact...");
        API.get("/contact")
            .then(res => {
                console.log("Contact messages received:", res.data);
                setList(res.data);
            })
            .catch(err => {
                console.error("Error fetching contact messages:", err);
                console.error("Error details:", err.response?.data || err.message);
                setList([]);
            })
            .finally(() => setLoading(false));
    };

    useEffect(() => {
        fetchMessages();
    }, []);

    const handleViewMessage = (msg) => {
        setSelectedMessage(msg);
        setIsModalOpen(true);
    };

    const handleDelete = async (id) => {
        if (window.confirm("Delete this message?")) {
            try {
                await API.delete(`/contact/${id}`);
                showToast("Message deleted");
                fetchMessages();
            } catch (err) {
                showToast("Error deleting message", "error");
            }
        }
    };

    const showToast = (message, type = "success") => {
        setToast({ message, type });
    };

    return (
        <div className="admin-card">
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "20px" }}>
                <h2 style={{ margin: 0 }}>Contact Messages</h2>
            </div>

            {loading ? (
                <p>Loading messages...</p>
            ) : (
                <div style={{ overflowX: "auto" }}>
                    <table className="admin-table">
                        <thead>
                            <tr>
                                <th>Date</th>
                                <th>Name</th>
                                <th>Email</th>
                                <th>Phone</th>
                                <th>Message Snippet</th>
                                <th>Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            {list.map((x, index) => (
                                <tr key={x.ContactMessageId || index}>
                                    <td>{x.CreatedDate ? new Date(x.CreatedDate).toLocaleDateString() : 'N/A'}</td>
                                    <td><strong>{x.Name}</strong></td>
                                    <td>{x.Email}</td>
                                    <td>{x.Phone}</td>
                                    <td style={{ maxWidth: "200px", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                                        {x.Message}
                                    </td>
                                    <td>
                                        <button className="btn btn-outline" onClick={() => handleViewMessage(x)} style={{ padding: "4px 8px", marginRight: "8px" }}>View</button>
                                        <button className="btn btn-outline" onClick={() => handleDelete(x.ContactMessageId)} style={{ padding: "4px 8px", color: "var(--danger)" }}>Delete</button>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            )}

            <Modal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} title="Message Details">
                {selectedMessage && (
                    <div style={{ padding: "10px 0" }}>
                        <div style={{ marginBottom: "15px", display: "grid", gridTemplateColumns: "100px 1fr", gap: "10px" }}>
                            <span style={{ color: "var(--text-muted)", fontWeight: "600" }}>From:</span>
                            <span>{selectedMessage.Name}</span>

                            <span style={{ color: "var(--text-muted)", fontWeight: "600" }}>Email:</span>
                            <span>{selectedMessage.Email}</span>

                            <span style={{ color: "var(--text-muted)", fontWeight: "600" }}>Phone:</span>
                            <span>{selectedMessage.Phone}</span>

                            <span style={{ color: "var(--text-muted)", fontWeight: "600" }}>Date:</span>
                            <span>{selectedMessage.CreatedDate ? new Date(selectedMessage.CreatedDate).toLocaleString() : 'N/A'}</span>
                        </div>
                        <div style={{ background: "#f8fafc", padding: "15px", borderRadius: "8px", borderLeft: "4px solid var(--primary)", whiteSpace: "pre-wrap" }}>
                            {selectedMessage.Message}
                        </div>
                        <div style={{ marginTop: "20px", display: "flex", justifyContent: "flex-end" }}>
                            <button className="btn btn-primary" onClick={() => setIsModalOpen(false)}>Close</button>
                        </div>
                    </div>
                )}
            </Modal>

            {list.length === 0 && !loading && (
                <div style={{ textAlign: "center", padding: "40px", color: "var(--text-muted)" }}>
                    No messages received yet.
                </div>
            )}

            {toast && <Toast message={toast.message} type={toast.type} onClose={() => setToast(null)} />}
        </div>
    );
}

export default ContactMessages;